module.exports = __webpack_public_path__ + "static/media/levels_3_3.840e6f10.svg";